import { render, staticRenderFns } from "./UserShoppingCartList.vue?vue&type=template&id=4ccac356&scoped=true&"
import script from "./UserShoppingCartList.vue?vue&type=script&lang=js&"
export * from "./UserShoppingCartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccac356",
  null
  
)

export default component.exports